<template lang="html">

  <form id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-formulario">

      <div class="contenedor-input row-start">
        <label for="">{{$t('formulario.nombre_apellidos')}}*</label>
        <input type="text" class="input-text" v-validate="'required'" name="nombre"
          :placeholder="$t('formulario.nombre_apellidos')+'*'" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
      </div>


      <div class="contenedor-input row-start">
        <label for="">{{$t('formulario.telefono')}}*</label>
        <input type="text" class="input-text" v-validate="'required|length:9'" name="telefono"
          :placeholder="$t('formulario.telefono')+'*'" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
      </div>

      <div class="contenedor-input row-start">
        <label for="">{{$t('formulario.email')}}*</label>
        <input type="text" class="input-text" v-validate="'required|email'" name="email"
          :placeholder="$t('formulario.email')+'*'" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
      </div>

      <div class="contenedor-input row-start">
        <label for="">{{$t('formulario.mensaje')}}</label>
        <textarea :placeholder="$t('formulario.mensaje')" name="mensaje"></textarea>
      </div>

      <div class="contenedor-check">
        <input type="checkbox" id="politica-contacto" v-validate="'required'" name="politica">
        <label for="politica-contacto">{{$t('formulario.he_leido')}} <router-link
            :to="$t('enlaces.politica_proteccion')">{{$t('formulario.y_acepto')}}*</router-link></label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
      </div>

      <div class="contenedor-check">
        <input type="checkbox" id="suscripcion-contacto" name="newsletter">
        <label for="suscripcion-contacto">{{$t('formulario.texto_newsletter')}}</label>
      </div>

      <div class="contenedor-boton" :enviado="enviado">
        <button class="btn" :loading="loading"><span>{{$t('formulario.enviar')}}</span></button>
        <div class="gracias row-center">{{$t('formulario.recibido')}}</div>
      </div>

      <input type="hidden" name="tipo_contacto" :value="'aldonza'">
      <input type="hidden" name="lang" :value="lang">

    </div>

    <popup-condiciones></popup-condiciones>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { mapGetters, mapActions } from 'vuex'

  import popupCondiciones from '@/components/view-parts/contacto/popup-contacto';

  export default {
    name: 'formulario',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked: false,
        loading: false,
        enviado: false,
        showPopup: false,
        popupAceptado: false,
        dataform: {
          nombre: '',
          telefono: '',
          email: '',
          mensaje: '',
          newsletter: false,
          politica: false
        }
      }
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit: function () {

        this.clicked = true;
       
        this.$validator.validateAll().then(canSend => {
          
          if (canSend) {
            this.loading = true;
            this.sendContacto($("#formContacto").serialize())
              .then(result => {
                if (result) {
                  this.enviado = true;
                  $("#formContacto")[0].reset();
                }
                this.loading = false;
              }).catch(e => {
                this.loading = false;
              });

          }
        });


      },
      aceptoPopup: function () {
        this.popupAceptado = true;
        this.showPopup = false;
      }
    },
    components: {
      'popup-condiciones': popupCondiciones
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    }
  }
</script>

<style scoped lang="scss">
  .contenedor-input,
  .contenedor-check,
  .contenedor-boton {
    opacity: 0;
    transform: translateY(200px);
    transition-duration: 1s;
  }

  [show=true] .contenedor-input,
  [show=true] .contenedor-check,
  [show=true] .contenedor-boton,
  [show=true] .showpopup,
  .contacto-movil .contenedor-input,
  .contacto-movil .contenedor-check,
  .contacto-movil .contenedor-boton,
  .contacto-movil .showpopup {
    opacity: 1;
    transform: translateY(0);
  }


  @for $i from 1 through 10 {
    [show=true] .rrss a:nth-child(#{$i}) {
      transition-delay: #{$i / 10 + .5}s;
    }

    [show=true] .formulario form>*:nth-child(#{$i}),
    .contacto-movil .formulario form>*:nth-child(#{$i}),
      {
      transition-delay: #{$i / 10 + .5}s;
    }
  }

  .showpopup {
    margin-bottom: 20px;
    font-size: 12px;
    text-decoration: underline;
    color: white;
    cursor: pointer;
    opacity: 0;
    transform: translateY(200px);
    transition-duration: 1s;

    &[error="1"] {
      color: #d4de3f;
      transition-delay: 0s;
      transition-duration: 0s;
    }
  }

  .contenedor-formulario {
    width: 50%;
  }

  form {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  @media screen and (max-width:830px) {

    .contenedor-formulario {
      width: 100%;
      margin-bottom: 20px;
    }

    form {
      flex-wrap: wrap;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue